export const toAbsoluteUrl = (pathname: string) => process.env.PUBLIC_URL + pathname
export const toAbsoluteUrlWithSubdomain = (pathname: string) => process.env.REACT_APP_BACK_END_HOST + pathname
